module.exports = __webpack_public_path__ + "static/img/logo_yfw.894af9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_yfw.png
// module id = +x5X
// module chunks = 1